/* AUMI — <hero-slideshow>: crossfade, autoplay com pausa em hover/foco, bolinhas, setas e swipe */
if (!customElements.get('hero-slideshow')) {
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.counter = this.querySelector('[data-counter]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.viewport = this.querySelector('[data-viewport]');
      this.speed = Number(this.dataset.speed) || 6000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.userPaused = false;
      this.held = false;

      if (this.pauseButton && this.reducedMotion) this.pauseButton.hidden = true;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));

      this.pauseButton?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Retomar apresentação' : 'Pausar apresentação');
        this.restart();
      });

      this.addEventListener('mouseenter', () => this.hold(true));
      this.addEventListener('mouseleave', () => this.hold(false));
      this.addEventListener('focusin', () => this.hold(true));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.hold(false);
      });

      this.viewport?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      });

      let startX = null;
      this.viewport?.addEventListener('pointerdown', (event) => { startX = event.clientX; });
      this.viewport?.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) > 48) this.go(this.index + (delta < 0 ? 1 : -1));
      });

      document.addEventListener('visibilitychange', () => this.restart());
      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.findIndex((slide) => slide.contains(event.target) || slide === event.target);
          if (i > -1) { this.userPaused = true; this.go(i); }
        });
        document.addEventListener('shopify:block:deselect', () => { this.userPaused = false; this.restart(); });
      }

      this.restart();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    hold(state) {
      if (this.held === state) return;
      this.held = state;
      this.classList.toggle('is-held', state);
      if (state) clearInterval(this.timer);
      else this.restart();
    }

    go(target) {
      const total = this.slides.length;
      const next = (target + total) % total;
      if (next === this.index) return;
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('inert', !active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === next);
        if (i === next) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.counter) this.counter.textContent = String(next + 1).padStart(2, '0');
      this.dataset.tone = this.slides[next].dataset.tone || 'dark';
      this.index = next;
      this.restart();
    }

    restart() {
      clearInterval(this.timer);
      const playing = this.autoplay && !this.userPaused && !document.hidden;
      /* reinicia a barrinha de progresso da bolinha ativa */
      this.dataset.playing = 'false';
      void this.offsetWidth;
      this.dataset.playing = String(playing);
      if (playing && !this.held) {
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }
    }
  }
  customElements.define('hero-slideshow', HeroSlideshow);
}
